<template>
  <transition
    name="animate__fadeIn"
    :enter-active-class="
      'animate__animated animate__fadeIn animate__delay-' +
      (index >= 7 ? 1 : index + 1) +
      's-list'
    "
    appear
  >
    <button
      class="mb-lg-1"
      :key="index"
      @click="openGameTable(table.clubId, table.id)"
    >
      <v-col
        cols="12"
        align-self="center"
        class="d-flex justify-center mt-lg-0 py-1 py-lg-0"
      >
        <v-container
          class="d-flex justify-center my-table-container"
          :class="{ 'mobile-my-table-container': mobileMenu }"
          fluid
        >
          <v-row>
            <v-col
              cols="6"
              align-self="center"
              class="d-flex justify-start pb-0 pt-1"
            >
              <span class="primaryText--text font-size-medium-small">
                {{ table.name | add3DotsToText(dotsToTextArg) }}
              </span>
            </v-col>
            <v-col
              cols="6"
              align-self="center"
              class="d-flex justify-center pb-0 pt-1"
            >
              <span class="secondary--text font-size-small">
                {{ $translate("club") }} {{ $translate("id") }}:
                {{ table.clubId }}
              </span>
            </v-col>
            <v-col
              cols="6"
              align-self="center"
              class="d-flex justify-start py-0"
            >
              <span class="secondary--text font-size-small">
                {{ table.tableType }}
              </span>
              <span class="ml-2 secondary--text font-size-small">
                {{ table.smallBlind | measurementUnit }}/{{
                  table.bigBlind | measurementUnit
                }}
              </span>
            </v-col>
            <v-col
              cols="6"
              align-self="center"
              class="d-flex justify-center py-0"
            >
              <v-icon small color="success">mdi-account</v-icon>
              <span class="ml-1 secondary--text font-size-xs">
                {{ table.countPlayers }}/{{ table.seats }}
              </span>
            </v-col>
            <v-col
              cols="6"
              align-self="center"
              class="d-flex justify-center py-1"
            >
              <v-row justify="center">
                <v-col
                  cols="2"
                  align-self="center"
                  class="pa-0 d-flex justify-start ml-1 mr-lg-1 mb-1"
                >
                  <v-img
                    :src="require('@/assets/new-timer-icon.svg')"
                    max-width="14px"
                  />
                </v-col>
                <v-col
                  cols="8"
                  align-self="center"
                  class="d-flex justify-start pl-1 justify-lg-start pa-1"
                >
                  <span class="font-size-xs secondary--text">
                    {{ table.runningTime | formatTime(false) }}
                  </span>
                </v-col>
              </v-row>

              <!--                                <v-icon small color="success">mdi-clock</v-icon>-->
              <!--                                <span-->
              <!--                                    class="ml-1 secondary&#45;&#45;text font-size-xs"-->
              <!--                                >-->
              <!--                                00:00:30-->
              <!--                              </span>-->
            </v-col>
            <v-col
              cols="6"
              align-self="center"
              class="d-flex justify-center py-0"
            >
              <v-icon small color="success"
                >mdi-checkbox-blank-circle-outline</v-icon
              >
              <span class="ml-1 secondary--text font-size-xs">
                {{ table.avgPot | measurementUnit(true) }}
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </button>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PlayingTable",
  props: { table: Object, index: Number },
  data() {
    return {
      windowWidth: 0,
    };
  },
  computed: {
    ...mapGetters(["mobileMenu"]),
    dotsToTextArg() {
      // Change 1500 to the actual value you consider as 'xl' screen size
      return this.windowWidth >= 1500 ? 15 : 10;
    },
  },
  methods: {
    openGameTable(clubId, tableId) {
      this.$router.push(`/game/${tableId}/${clubId}`);
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.my-table-container {
  border-radius: 15px;
  border: 1px solid #707070;
}
.mobile-my-table-container {
  background-color: var(--v-vListBackground) !important;
  border: 1px solid var(--v-vListBorderColor) !important;
}
</style>
